// 角色组实体类
export interface GroupRoleInterface {
  // 名称
  title?: string;
  // 角色id
  key?: string;
  // 类型(role-角色，group-角色组)
  type?: string;
  // 编号
  code?: string;
  // 是否叶子节点
  leaf?: boolean;
  // 是否被选中
  selected?: boolean;
  // 是否展开(叶子节点无效)
  expanded?: boolean;
  children?: Array<GroupRoleInterface>;
}
// 组件参数
export class ComponentOption {
  roleGroupCode?: string = null; // 角色组编码，只加载此角色组下的角色列表;
  count?: number = 0; // 最多人数限制，默认不限制
  defaultContacts?: Array<any> = []; // 默认已被选择的人员
  userTypes?: string = null; // 人员类型，多个类型以逗号隔开。当按部门查询且只选学生(onlyStudent = true)时默认为“2,3”,更改不起作用,其他情况下无默认值可做修改；
}
